import React, { useState } from "react";
import { FaSearch, FaFileExport, FaCaretDown, FaFilePdf, FaFileCsv, FaFileExcel } from "react-icons/fa";
import "./ListaAlunos.css";

const FiltroAlunos = ({ filtroNome, setFiltroNome, filtroClasse, setFiltroClasse, onExportar }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleExport = (formato) => {
    onExportar(formato);
    setShowDropdown(false);
  };

  return (
    <div className="filtro-nome">
      <FaSearch className="icone-pesquisa" />
      <input
        type="text"
        placeholder="Buscar por nome ou código"
        value={filtroNome}
        onChange={(e) => setFiltroNome(e.target.value)}
      />

      <select value={filtroClasse} onChange={(e) => setFiltroClasse(e.target.value)}>
        <option value="">Todas as Classes</option>
        {[...Array(12)].map((_, i) => (
          <option key={i + 1} value={`${i + 1}ª Classe`}>
            {i + 1}ª Classe
          </option>
        ))}
      </select>

      <div
        className="btn-export-container"
        tabIndex={0}
        onBlur={() => setShowDropdown(false)}
        style={{ position: "relative" }}
      >
        <button className="btn-azul" onClick={toggleDropdown}>
          <FaFileExport style={{ marginRight: "5px" }} /> Exportar <FaCaretDown />
        </button>

        {showDropdown && (
          <ul
            className="dropdown-lista"
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              background: "white",
              border: "1px solid #ccc",
              borderRadius: "4px",
              minWidth: "140px",
              marginTop: "4px",
              listStyle: "none",
              padding: 0,
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
            }}
          >
            <li style={dropdownItemStyle} onMouseDown={() => handleExport("pdf")}>
              <FaFilePdf /> PDF
            </li>
            <li style={dropdownItemStyle} onMouseDown={() => handleExport("excel")}>
              <FaFileExcel /> Excel
            </li>
            <li style={dropdownItemStyle} onMouseDown={() => handleExport("csv")}>
              <FaFileCsv /> CSV
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

const dropdownItemStyle = {
  padding: "8px 15px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  userSelect: "none",
};

export default FiltroAlunos;
